export const tideExtremesSelector = state => state.tideExtremes
